import SwitchWithIcon from "components/common/SwitchWithIcon";

const EmailCard = ({ checked, onChange }) => {
  return (
    <div className="h-full rounded-lg border border-gray-200 bg-gray-50/40 p-4 flex flex-col">
      <div className="flex items-start justify-between gap-4">
        <p className="text-sm font-medium text-gray-800 leading-snug pr-2">
          Send follow-up email to non-compliant workers
        </p>
        <div className="shrink-0 pt-0.5">
          <SwitchWithIcon onChange={onChange} checked={checked} />
        </div>
      </div>
      <p className="text-xs text-gray-500 mt-3 leading-relaxed">
        When enabled, weekly reminders are sent to workers with incomplete mandatory documents and forms.
        Sent Fridays at 6:00 PM (Melbourne time).
      </p>
    </div>
  );
};

export default EmailCard;
